<template>
  <div class="paper_preview" ref="paperPreviewRef" v-loading="downloading" element-loading-text="正在生成试卷PDF..."
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
    <div>试卷预览</div>
    <div class="paper_content flex mt-20">
      <div class="paper_left pr-20">
        <el-image class="examination_left_information" :src="iconPath('examination_left_information.png')"></el-image>
      </div>
      <div class="splid_line"></div>
      <div class="paper_right pl-20 flex-1">
        <div ref="paperHeader">
          <div class="paper_title" ref="paperTitle">
            <!-- 江苏省南京市高淳区2023-2024学年七年级下学期6月期未英语模拟试题 -->
            {{ paperInfo.paperName }}
          </div>
          <div class="paper_time flex mt-15" ref="paperTime">
            <div>考试时间：{{paperContent.answerTime}}分钟</div>
            <div class="ml-20">满分：{{paperContent.fullScore}}分</div>
          </div>
          <div class="paper_time paper_filled flex mt-10" ref="paperFilled">
            <div>姓名：<span>__________</span></div>
            <div class="ml-15">班级：<span>__________</span></div>
            <div class="ml-15">学号：<span>__________</span></div>
          </div>
          <div class="paper_score mt-15" ref="paperScore">
            <table>
              <thead>
                <tr>
                  <th>题号</th>
                  <th v-for="i in paperContent.paperContext?.length" :key="i">{{ numberToChinese(i) }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>评分</td>
                  <td v-for="i in paperContent.paperContext?.length" :key="i"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="paper_attention mt-15" ref="paperAttention">
            <div>*注意事项：</div>
            <div>1.按时入场，不迟到，不早退。</div>
            <div>2.带好准考证、有效证件及规定文具，严禁携带手机、智能手表、资料等违禁物品。</div>
            <div>3.按指定座位就座，按要求填写个人信息。</div>
            <div>4.遵守考场纪律，不抄袭、不交头接耳、不违规作弊。</div>
            <div>5.听从监考老师安排，考试结束后立即停笔，有序离场。</div>
          </div>
        </div>
        <div class="paper_content_box">
          <div class="paper_total mt-15" v-for="(item, index) in paperContent.paperContext" :key="index"
            :ref="'section_block_' + index">
            <div class="paper_total_title flex Flexalign" :ref="'section_title_' + index">
              <table class="mr-15">
                <thead>
                  <tr>
                    <th>阅卷人</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>得分</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <div>
                {{ numberToChinese(index + 1) }}、{{ item.questionTypeName }}（共{{
                  item.questions.length
                }}题，满分{{ item.totalScore }}分）
              </div>
            </div>
            <div class="paper_question" v-for="(sitem, sindex) in item.questions" :key="sindex">
              <choice :questionInfo="sitem" class="mt-15" v-if="sitem.questionTypeId == 1 || sitem.questionTypeId == 9"
                :ref="'question_' + getUniqueId(item, sitem, sindex)"></choice>
              <multipleChoice :questionInfo="sitem" class="mt-15" v-if="sitem.questionTypeId == 2"
                :ref="'question_' + getUniqueId(item, sitem, sindex)"></multipleChoice>
              <fillIn :questionInfo="sitem" class="mt-15" v-if="sitem.questionTypeId == 3 || sitem.questionTypeId == 14"
                :ref="'question_' + getUniqueId(item, sitem, sindex)"></fillIn>
              <trueOrFalse :questionInfo="sitem" class="mt-15"
                v-if="sitem.questionTypeId == 4 || sitem.questionTypeId == 11"
                :ref="'question_' + getUniqueId(item, sitem, sindex)"></trueOrFalse>
              <sort :questionInfo="sitem" class="mt-15" v-if="sitem.questionTypeId == 6 || sitem.questionTypeId == 15"
                :ref="'question_' + getUniqueId(item, sitem, sindex)"></sort>
              <textAnswer :questionInfo="sitem" class="mt-15" v-if="
                sitem.questionTypeId == 7 ||
                sitem.questionTypeId == 13 ||
                sitem.questionTypeId == 16 ||
                sitem.questionTypeId == 17
              " :ref="'question_' + getUniqueId(item, sitem, sindex)">
              </textAnswer>
              <informationMatch :questionInfo="sitem" class="mt-15" v-if="
                sitem.questionTypeId == 32
              " :ref="'question_' + getUniqueId(item, sitem, sindex)">
              </informationMatch>
              <comprehensieAnswer :questionInfo="sitem" class="mt-15" v-if="
                sitem.questionTypeId == 99 ||
                sitem.questionTypeId == 101 ||
                sitem.questionTypeId == 102 ||
                sitem.questionTypeId == 103
              " :ref="'question_' + getUniqueId(item, sitem, sindex)"></comprehensieAnswer>
              <composition :questionInfo="sitem" class="mt-15"
                v-if="sitem.questionTypeId == 21 || sitem.questionTypeId == 22"
                :ref="'question_' + getUniqueId(item, sitem, sindex)"></composition>
            </div>
          </div>
          <div class="answer_after_paper_box" v-for="(item, index) in paperContent.paperContext" :key="index">
            <div class="answer_after_paper" v-for="(sitem, sindex) in item.questions" :key="sindex">
              <div>第{{ sitem.questionNumber }}题答案解析</div>
              <div class="answer_top flex FlexBetween">
                <div class="flex">
                  <div>参考答案：<span class="correct_value_answer">{{
                    this.getChoiceLabel(sitem.questionContext?.answer, sitem.questionContext?.options)
                  }}</span></div>
                </div>
              </div>
              <div class="question_analyze_1">
                <div class="question_analyze mar_top_10">【试题分析】</div>
                <div class="mar_top_10" v-html="$Tools.handlerImg(sitem.questionAnalyze)" v-mathml></div>
              </div>
              <div class="question_analyze_2">
                <div class="question_analyze mar_top_10">【解析】</div>
                <div class="mar_top_10" v-html="$Tools.handlerImg(sitem.questionExplanation)" v-mathml></div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 20px"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import testPaper from "./testPaper.json";
import choice from "./components/choice.vue";
import multipleChoice from "./components/multipleChoice.vue";
import fillIn from "./components/fillIn.vue";
import trueOrFalse from "./components/trueOrFalse.vue";
import sort from "./components/sort.vue";
import textAnswer from "./components/textAnswer.vue";
import comprehensieAnswer from "./components/comprehensieAnswer.vue";
import composition from "./components/composition.vue";
import informationMatch from "./components/informationMatch.vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
export default {
  name: "GjkcH5PaperDownloadPreview",
  components: {
    choice,
    multipleChoice,
    fillIn,
    trueOrFalse,
    sort,
    textAnswer,
    comprehensieAnswer,
    composition,
    informationMatch,
  },
  props: {
    paperConfig: {
      type: Object,
      default: () => ({
        paperSize: 'A4',
        paperStyleSelectList: [],
        answerShow: false,
        answerPosition: 1,
        additionalSelectList: [],
        audioDownload: 1
      })
    },
    paperInfo: {}
  },

  data() {
    return {
      paperContent: {},
      downloading: false, // 新增：控制loading状态
    };
  },
  watch: {
    // 监听配置变化，更新预览
    paperConfig: {
      handler() {
        this.updatePreviewStyle();
      },
      deep: true,
    }
  },

  mounted() {
    this.initPaperInfo();
    this.$nextTick(() => {
      this.updatePreviewStyle();
    })
  },
  inject: {
    refreshPaperInfo: {
      from: 'refreshPaperInfo',  // 从 provide 的 refreshPaperInfo 注入
      default: null  // 提供默认值，防止祖先组件没有提供时报错
    },
    paperDocumentId: {
      from: 'paperDocumentId',
      default: null
    }
  },

  methods: {
    getChoiceLabel(value, options) {
      let label = "";
      options.forEach(item => {
        if (item.serial == value) {
          label = item.label;
        }
      })
      return label;
    },
    // 根据配置更新预览样式
    updatePreviewStyle() {
      const config = this.paperConfig;

      // 根据配置显示/隐藏对应元素
      const styleElements = {
        '密封线': '.paper_left',
        '注意事项': '.paper_attention',
        '考试时间': '.paper_time',
        '考生填写': '.paper_filled',
        '总评分': '.paper_score',
        '大题评分区': '.paper_total_title table'
      };

      // 遍历所有样式元素，根据配置控制显示
      Object.entries(styleElements).forEach(([key, selector]) => {
        const elements = this.$el.querySelectorAll(selector);
        const shouldShow = config.paperStyleSelectList.includes(key);
        elements.forEach(el => {
          if (el) el.style.display = shouldShow ? '' : 'none';
        });
      });

      // 处理答案解析显示
      this.$el.querySelectorAll('.topic_answer').forEach(el => {
        el.style.display = config.answerShow ? '' : 'none';
        el.style.padding = config.answerShow ? '20px' : '0';
      });

      const answerElements = {
        '试题答案': '.answer_top',
        '试题分析': '.question_analyze_1',
        '试题解析': '.question_analyze_2',
      };
      Object.entries(answerElements).forEach(([key, selector]) => {
        const elements = this.$el.querySelectorAll(selector);
        const shouldShow = config.additionalSelectList.includes(key);
        elements.forEach(el => {
          if (el) el.style.display = shouldShow ? '' : 'none';
        });
      });

      // 处理附加位置（题后/卷后）
      // 需要根据具体组件逻辑实现
      if (config.answerPosition == 1) {
        // 题后
        // 先将topic_answer去掉
        this.$el.querySelectorAll('.answer_after_paper').forEach(el => {
          el.style.display = 'none';
          el.style.padding = '0';
        });
        this.$el.querySelectorAll('.topic_answer').forEach(el => {
          el.style.display = config.answerShow ? '' : 'none';
          el.style.padding = config.answerShow ? '20px' : '0';
        });
      } else {
        // 卷后
        // 先将topic_answer去掉
        this.$el.querySelectorAll('.topic_answer').forEach(el => {
          el.style.display = 'none';
          el.style.padding = '0';
        });
        this.$el.querySelectorAll('.answer_after_paper').forEach(el => {
          el.style.display = config.answerShow ? '' : 'none';
          el.style.padding = config.answerShow ? '20px' : '0';
        });
      }
    },
    numberToChinese(num) {
      const chineseNums = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
      ];
      return chineseNums[num - 1];
    },
    initPaperInfo() {
      // this.paperContent = testPaper.data;
      this.paperContent = this.paperInfo;
      this.paperContent.paperContext.forEach((item) => {
        item.totalScore = 0;
        item.questions.forEach((sitem) => {
          item.totalScore += sitem.questionScore || 0;
        });
      });
    },
    getUniqueId(item, sitem, index) {
      return `${item.questionTypeId}_${sitem.id || index}_${index}`;
    },
    // 从题目中提取音频URL
    extractAudioUrls(paperContent) {
      const audioUrls = new Set(); // 使用Set去重

      const extractFromQuestion = (question) => {
        // 从otherRule中提取音频URL
        const audioUrl = this.getAudioUrlFromQuestion(question);
        if (audioUrl) {
          audioUrls.add(audioUrl);
        }

        // 如果有子题，递归提取
        if (question.questionContext?.subQuestions?.length) {
          question.questionContext.subQuestions.forEach(subQ => {
            const subAudioUrl = this.getAudioUrlFromQuestion(subQ);
            if (subAudioUrl) {
              audioUrls.add(subAudioUrl);
            }
          });
        }
      };

      // 遍历所有题型和题目
      paperContent.paperContext?.forEach(section => {
        section.questions?.forEach(question => {
          extractFromQuestion(question);
        });
      });

      return Array.from(audioUrls);
    },

    // 从题目中获取音频URL（参考choice.vue中的getAudioUrl）
    getAudioUrlFromQuestion(question) {
      if (!question.otherRule) return null;

      try {
        const ruleInfo = JSON.parse(question.otherRule);
        if (ruleInfo?.listeningRule?.audioUrl) {
          return ruleInfo.listeningRule.audioUrl;
        }
      } catch (e) {
        console.error('解析音频URL失败:', e);
      }
      return null;
    },

    // 从题目中提取音频信息（返回包含题目编号和URL的对象）
    extractAudioInfo(paperContent) {
      const audioList = []; // 使用数组存储，保留题目信息

      const extractFromQuestion = (question, parentNumber = '') => {
        // 从otherRule中提取音频URL
        const audioUrl = this.getAudioUrlFromQuestion(question);
        if (audioUrl) {
          // 生成题目编号（如果parentNumber存在，说明是子题）
          const questionNumber = parentNumber || question.questionNumber;
          audioList.push({
            url: audioUrl,
            number: questionNumber,
            // 如果是子题，可以额外记录父题信息
            parentNumber: parentNumber || null,
            // 用于生成文件名
            fileName: this.generateAudioFileName(questionNumber, audioUrl)
          });
        }

        // 如果有子题，递归提取
        if (question.questionContext?.subQuestions?.length) {
          question.questionContext.subQuestions.forEach((subQ, subIndex) => {
            // 子题编号格式：母题号.子题序号
            const subNumber = `${question.questionNumber}.${subIndex + 1}`;
            extractFromQuestion(subQ, subNumber);
          });
        }
      };

      // 遍历所有题型和题目
      paperContent.paperContext?.forEach(section => {
        section.questions?.forEach(question => {
          extractFromQuestion(question);
        });
      });

      console.log('提取的音频信息:', audioList);
      return audioList;
    },

    // 生成音频文件名
    generateAudioFileName(questionNumber, url) {
      // 提取文件扩展名
      let extension = 'mp3'; // 默认
      try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        const match = pathname.match(/\.([a-zA-Z0-9]+)(\?|$)/);
        if (match) {
          extension = match[1];
        }
      } catch (e) {
        // 忽略错误，使用默认扩展名
      }

      // 替换题目编号中的点号为下划线（避免文件名中的点造成混淆）
      const safeNumber = String(questionNumber).replace(/\./g, '_');
      return `第${safeNumber}题.${extension}`;
    },

    // 下载单个音频文件（修改版）
    async downloadAudioFile(audioInfo) {
      try {
        const response = await fetch(audioInfo.url, {
          mode: 'cors',
          credentials: 'omit'
        });
        const blob = await response.blob();

        return {
          fileName: audioInfo.fileName,
          blob,
          number: audioInfo.number // 保留题目编号信息
        };
      } catch (error) {
        console.error(`下载音频失败: ${audioInfo.url}`, error);
        return null;
      }
    },

    // 修改 downloadPaperWithAudio 方法
    async downloadPaperWithAudio() {
      // 开始下载，显示loading
      this.downloading = true;

      try {
        // 1. 提取所有音频信息（包含题目编号）
        const audioList = this.extractAudioInfo(this.paperContent);
        console.log('找到音频文件:', audioList.length, '个');

        if (audioList.length === 0) {
          // 如果没有音频，直接下载PDF
          const pdfBlob = await this.generatePDFBlob();
          saveAs(pdfBlob, '试卷.pdf');
          this.$message.success('试卷下载成功（无音频）');
          return;
        }

        // 2. 创建ZIP文件
        const zip = new JSZip();

        // 3. 先下载所有音频文件
        const audioDownloadPromises = audioList.map((audioInfo, index) =>
          this.downloadAudioFile(audioInfo, index)
        );

        // 显示下载进度提示
        this.$message.info(`正在下载 ${audioList.length} 个音频文件...`);

        const audioResults = await Promise.all(audioDownloadPromises);

        // 4. 将音频添加到ZIP（使用题目编号作为文件名）
        let successCount = 0;
        audioResults.forEach((result) => {
          if (result && result.blob) {
            zip.file(`音频/${result.fileName}`, result.blob);
            successCount++;
          }
        });

        console.log(`成功下载 ${successCount}/${audioList.length} 个音频文件`);

        // 5. 生成PDF并添加到ZIP
        const pdfBlob = await this.generatePDFBlob();
        zip.file('试卷.pdf', pdfBlob);

        // 6. 可选：生成一个音频文件列表说明
        if (audioList.length > 0) {
          const listContent = audioList.map(info =>
            `${info.fileName} - 对应第 ${info.number} 题`
          ).join('\n');
          zip.file('音频文件列表.txt', listContent);
        }

        // 7. 生成ZIP文件并下载
        const zipBlob = await zip.generateAsync({
          type: 'blob',
          compression: 'DEFLATE',
          compressionOptions: {
            level: 6
          },
          onUpdate: (metadata) => {
            // 可以在这里显示压缩进度
            console.log('压缩进度:', metadata.percent.toFixed(2) + '%');
          }
        });

        // 8. 保存ZIP文件
        const fileName = `试卷_${new Date().getTime()}.zip`;
        saveAs(zipBlob, fileName);

        this.$message.success(`试卷下载成功，包含 ${successCount} 个音频文件`);
        this.recordExaminationDownload();
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('下载失败，请重试');
      } finally {
        this.downloading = false;
      }
    },

    // 方法1: 将跨域图片转换为 Base64 (核心方法)
    async convertCrossOriginImageToBase64(imgElement) {
      return new Promise((resolve) => {
        const src = imgElement.src;
        // 跳过已经处理过的、空白的或已经是 data: 协议的图片
        if (!src || src.startsWith('data:') || imgElement.getAttribute('data-converted') === 'true') {
          resolve();
          return;
        }

        // 使用 fetch 请求图片（绕过 CORS 限制）
        fetch(src, {
          method: 'GET',
          mode: 'cors', // 尝试请求，如果服务器不支持，会进入 catch
          credentials: 'omit',
          headers: {
            'Accept': 'image/webp,image/apng,image/*,*/*;q=0.8',
          }
        })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.blob();
          })
          .then(blob => {
            // 将 Blob 转换为 Base64
            const reader = new FileReader();
            reader.onloadend = () => {
              imgElement.src = reader.result; // 替换 src 为 Base64
              imgElement.setAttribute('data-converted', 'true');
              console.log('图片转换成功:', src.substring(0, 50) + '...');
              resolve();
            };
            reader.onerror = () => {
              console.warn('FileReader 转换失败:', src);
              resolve(); // 即使失败也继续，避免阻塞
            };
            reader.readAsDataURL(blob);
          })
          .catch(error => {
            console.warn('Fetch 失败，图片可能无法转换:', src, error.message);
            // 失败时不阻塞，原样保留
            resolve();
          });
      });
    },

    // 方法2: 批量转换容器内所有图片
    async convertAllImagesInContainer(container) {
      const images = container.querySelectorAll('img');
      const convertPromises = [];

      images.forEach(img => {
        // 只处理尚未转换的、非 data 协议的图片
        if (img.src && !img.src.startsWith('data:') && img.getAttribute('data-converted') !== 'true') {
          convertPromises.push(this.convertCrossOriginImageToBase64(img));
        }
      });

      if (convertPromises.length > 0) {
        await Promise.all(convertPromises);
        console.log(`已尝试转换 ${convertPromises.length} 张图片`);
      }
    },

    // 生成PDF并返回Blob
    async generatePDFBlob() {
      const container = this.$refs.paperPreviewRef?.querySelector('.paper_content');
      if (!container) throw new Error('未找到试卷内容');

      // ===== 新增：转换所有跨域图片 =====
      await this.convertAllImagesInContainer(container);
      // 额外等待一下，确保图片替换完成
      await this.$nextTick();

      const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const imgWidth = pdfWidth - margin * 2;

      // 保存原始样式
      const originalStyles = {
        height: container.style.height,
        maxHeight: container.style.maxHeight,
        overflow: container.style.overflow,
        width: container.style.width,
        maxWidth: container.style.maxWidth
      };

      // 临时修改样式
      container.style.height = 'auto';
      container.style.maxHeight = 'none';
      container.style.overflow = 'visible';
      container.style.width = '210mm';
      container.style.maxWidth = '210mm';
      container.style.margin = '0 auto';
      container.style.background = 'white';

      await this.$nextTick();

      const scrollHeight = container.scrollHeight;
      const scrollWidth = container.scrollWidth;

      const canvas = await html2canvas(container, {
        scale: 2,
        useCORS: true,
        logging: false,
        windowWidth: scrollWidth,
        windowHeight: scrollHeight,
        allowTaint: false,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (imgHeight <= pdfHeight - margin * 2) {
        pdf.addImage(imgData, "JPEG", margin, margin, imgWidth, imgHeight);
      } else {
        const totalPages = Math.ceil(imgHeight / (pdfHeight - margin * 2));

        for (let i = 0; i < totalPages; i++) {
          if (i > 0) pdf.addPage();

          const yOffset = i * (pdfHeight - margin * 2) * (canvas.width / imgWidth);
          const pageHeightOnCanvas = Math.min(
            canvas.height - yOffset,
            (pdfHeight - margin * 2) * (canvas.width / imgWidth)
          );

          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = canvas.width;
          pageCanvas.height = pageHeightOnCanvas;
          const ctx = pageCanvas.getContext('2d');
          ctx.drawImage(
            canvas,
            0, yOffset, canvas.width, pageHeightOnCanvas,
            0, 0, pageCanvas.width, pageHeightOnCanvas
          );

          const pageImgData = pageCanvas.toDataURL("image/jpeg", 0.95);
          const pageImgHeight = (pageCanvas.height * imgWidth) / pageCanvas.width;

          pdf.addImage(pageImgData, "JPEG", margin, margin, imgWidth, pageImgHeight);

          pdf.setPage(i + 1);
          pdf.setFontSize(10);
          pdf.setTextColor(100);
          pdf.text(`Page ${i + 1}`, pdfWidth / 2, pdfHeight - 5, { align: "center" });
        }
      }

      // 恢复原始样式
      Object.assign(container.style, originalStyles);

      // 将PDF转换为Blob
      return pdf.output('blob');
    },

    // 从URL生成文件名
    getFileNameFromUrl(url, index) {
      try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // 提取文件名，如果没有则使用索引
        let fileName = pathname.split('/').pop();
        if (!fileName || !fileName.includes('.')) {
          fileName = `audio_${index + 1}.mp3`;
        }
        return fileName;
      } catch {
        return `audio_${index + 1}.mp3`;
      }
    },
    async downloadAsPDF() {
      // 开始下载，显示loading
      this.downloading = true

      try {
        const container = this.$refs.paperPreviewRef?.querySelector('.paper_content')
        if (!container) return

        const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" })
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        const margin = 10
        const imgWidth = pdfWidth - margin * 2

        // 保存原始样式
        const originalStyles = {
          height: container.style.height,
          maxHeight: container.style.maxHeight,
          overflow: container.style.overflow,
          width: container.style.width,
          maxWidth: container.style.maxWidth,
          position: container.style.position
        }

        // 临时修改样式，让容器能够完整展开
        container.style.height = 'auto'
        container.style.maxHeight = 'none'
        container.style.overflow = 'visible'
        container.style.width = '210mm'
        container.style.maxWidth = '210mm'
        container.style.margin = '0 auto'
        container.style.background = 'white'
        container.style.position = 'relative'

        await this.$nextTick()

        const scrollHeight = container.scrollHeight
        const scrollWidth = container.scrollWidth

        try {
          const canvas = await html2canvas(container, {
            scale: 2,
            useCORS: true,
            logging: false,
            windowWidth: scrollWidth,
            windowHeight: scrollHeight,
            allowTaint: false,
            backgroundColor: '#ffffff',
            onclone: (clonedDoc, clonedElement) => {
              clonedElement.style.height = 'auto'
              clonedElement.style.maxHeight = 'none'
              clonedElement.style.overflow = 'visible'
            }
          })

          const imgData = canvas.toDataURL("image/jpeg", 0.95)
          const imgHeight = (canvas.height * imgWidth) / canvas.width

          if (imgHeight <= pdfHeight - margin * 2) {
            pdf.addImage(imgData, "JPEG", margin, margin, imgWidth, imgHeight)
          } else {
            const totalPages = Math.ceil(imgHeight / (pdfHeight - margin * 2))

            for (let i = 0; i < totalPages; i++) {
              if (i > 0) pdf.addPage()

              const yOffset = i * (pdfHeight - margin * 2) * (canvas.width / imgWidth)
              const pageHeightOnCanvas = Math.min(
                canvas.height - yOffset,
                (pdfHeight - margin * 2) * (canvas.width / imgWidth)
              )

              const pageCanvas = document.createElement('canvas')
              pageCanvas.width = canvas.width
              pageCanvas.height = pageHeightOnCanvas
              const ctx = pageCanvas.getContext('2d')
              ctx.drawImage(
                canvas,
                0, yOffset, canvas.width, pageHeightOnCanvas,
                0, 0, pageCanvas.width, pageHeightOnCanvas
              )

              const pageImgData = pageCanvas.toDataURL("image/jpeg", 0.95)
              const pageImgHeight = (pageCanvas.height * imgWidth) / pageCanvas.width

              pdf.addImage(pageImgData, "JPEG", margin, margin, imgWidth, pageImgHeight)

              pdf.setPage(i + 1)
              pdf.setFontSize(10)
              pdf.setTextColor(100)
              pdf.text(`Page ${i + 1}`, pdfWidth / 2, pdfHeight - 5, { align: "center" })
            }
          }

          pdf.save("试卷预览.pdf")

          // 成功提示（可选）
          this.$message.success('试卷下载成功');
          this.recordExaminationDownload();
        } finally {
          // 恢复原始样式
          Object.assign(container.style, originalStyles)
        }
      } catch (error) {
        console.error('PDF生成失败:', error)
        // 失败提示
        this.$message.error('试卷下载失败，请重试')
      } finally {
        // 无论成功失败，都关闭loading
        this.downloading = false
      }
    },
    collectBlocks() {
      const blocks = []
      const paperPreview = this.$refs.paperPreviewRef
      if (!paperPreview) return blocks

      // 1. 先收集试卷主体内容（不包含答案区域）
      const paperContent = paperPreview.querySelector('.paper_content')
      if (!paperContent) return blocks

      // 克隆试卷主体内容（需要移除答案区域）
      const mainContent = paperContent.cloneNode(true)
      const answerBoxes = mainContent.querySelectorAll('.answer_after_paper_box')
      answerBoxes.forEach(box => box.remove()) // 移除答案区域

      // 添加主体内容块
      blocks.push({
        element: mainContent,
        forceNewPage: false // 不强制换页
      })

      // 2. 收集所有答案区域，每个答案区域作为一个独立的块
      const answerBoxesOriginal = paperPreview.querySelectorAll('.answer_after_paper_box')
      answerBoxesOriginal.forEach((box, index) => {
        blocks.push({
          element: box.cloneNode(true),
          forceNewPage: index === 0 // 第一个答案区域强制换页，后面的会自动跟随
        })
      })

      return blocks
    },
    // 试卷下载记录
    recordExaminationDownload() {
      let params = {
        paperId: this.paperInfo.paperId,
        fileFormat: "pdf",
        requestId: this.generateRequestId()
      };
      this.$Api.examination.recordExaminationDownload(params).then(async () => {
        // 下载成功后刷新试卷信息
        if (this.refreshPaperInfo) {
          try {
            await this.refreshPaperInfo();
            console.log('试卷信息刷新成功');
          } catch (error) {
            console.error('试卷信息刷新失败:', error);
          }
        } else {
          console.warn('refreshPaperInfo 方法未提供');
        }
      }).catch(() => { })
    },
    // 生成唯一ID
    generateRequestId() {
      // 组合多种随机源，确保唯一性
      const timestamp = Date.now(); // 时间戳
      const random1 = Math.random().toString(36).substring(2, 15); // 随机字符串1
      const random2 = Math.random().toString(36).substring(2, 15); // 随机字符串2
      const random3 = Math.floor(Math.random() * 1000000); // 随机数

      // 格式：时间戳-随机字符串1-随机字符串2-随机数
      return `${timestamp}-${random1}-${random2}-${random3}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.paper_preview {
  font-size: 16px;
  color: #303030;
  height: 100%;
  overflow: auto;

  .paper_content {
    height: 100%;

    .paper_left {
      // height: 100%;
      // border-right: 1px dashed #EBECED;

      .examination_left_information {}
    }

    .paper_right {
      border-left: 1px dashed #ebeced;

      .paper_title {
        margin: 0 auto;
        width: 400px;
        text-align: center;
        font-weight: 500;
        font-size: 18px;
        color: #303030;
      }

      .paper_time {
        font-size: 12px;
        color: #303030;
      }

      .paper_score {
        // margin: 20px 0;
        margin: 15px auto 0;

        table {
          width: 90%;
          border-collapse: collapse;
          text-align: center;
          font-family: "SimSun", "宋体", serif;

          th,
          td {
            border: 1px solid #979797;
            padding: 8px 4px;
            font-size: 14px;
            font-weight: normal;
            height: 32px;
          }

          th {
            // background-color: #f5f5f5;
            font-weight: normal;
          }

          td:first-child {
            // background-color: #f5f5f5;
          }

          td:not(:first-child) {

            // 评分单元格可以留空或添加下划线效果
            &:empty::before {
              content: "";
              display: inline-block;
              width: 100%;
            }
          }
        }
      }

      .paper_attention {
        font-size: 12px;
        color: #303030;
      }
    }

    .paper_content_box {
      .paper_total {
        .paper_total_title {
          font-size: 14px;
          font-weight: 600;

          table {
            // width: 20%;
            border-collapse: collapse;
            text-align: center;
            font-family: "SimSun", "宋体", serif;

            th,
            td {
              width: 50px;
              border: 1px solid #979797;
              padding: 4px;
              font-size: 12px;
              font-weight: normal;
              // height: 32px;
            }

            th {
              // background-color: #f5f5f5;
              font-weight: normal;
            }

            td:first-child {
              // background-color: #f5f5f5;
            }

            td:not(:first-child) {

              // 评分单元格可以留空或添加下划线效果
              &:empty::before {
                content: "";
                display: inline-block;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  .answer_after_paper {
    font-size: 12px;

    .answer_top {
      .error_value_answer {
        color: RGBA(255, 49, 49, 1);
      }

      .correct_value_answer {
        color: RGBA(0, 199, 88, 1);
      }

      .btn_ask {
        width: 64px;
        height: 28px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 14px;
        line-height: 28px;
        text-align: center;
        color: #fff;
      }
    }

    .question_analyze {
      color: #333333;
      font-weight: 600;
    }
  }
}

// @media print {
//   .paper_preview {
//     width: 100%;
//     margin: 0;
//     padding: 10mm;
//     background: white;
//   }
//   /* 隐藏不需要打印的元素，如按钮 */
//   .no-print {
//     display: none;
//   }
// }</style>
